import { render, staticRenderFns } from "./product-variants.vue?vue&type=template&id=05762d6a&"
import script from "./product-variants.vue?vue&type=script&lang=js&"
export * from "./product-variants.vue?vue&type=script&lang=js&"
import style0 from "./product-variants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports